import EasyPassClient from './EasyPassClient';

export default class {
  constructor(user) {
    this.easyPassClient = new EasyPassClient(user);
    this.apiVersion = 'v3';
    this.gatewayUri = 'api/acvapi';
    this.resourceUri = 'messages';
  }

  v2get(route, params = {}) {
    return this.easyPassClient.get(`${this.gatewayUri}/${this.apiVersion}/${this.resourceUri}/${route}`, params);
  }

  v2post(route, params = {}) {
    return this.easyPassClient.post(`${this.gatewayUri}/${this.apiVersion}/${this.resourceUri}/${route}`, params);
  }

  getAll(params) {
    return this.v2get('all', params);
  }

  getRecent() {
    return this.v2get('recent');
  }

  getAppLaunchMessage() {
    return this.v2get(
      'app_launch',
      {
        // mark_seen: false, // DEBUG: Set to false to persist app launch message
      },
    );
  }

  markAllSeen() {
    return this.v2post('seen');
  }

  markAllRead() {
    return this.v2post('read');
  }

  markRead(messageId) {
    return this.v2post(`${messageId}/read`);
  }
}
